<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados das Despesas - Serviços</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Combustíveis e lubrificantes</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Total</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoTotal"
                  v-model="formulario.ServicoTotal"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Utilização na bovinocultura de corte</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoTotalBovinoculturaCorte"
                  v-model="formulario.ServicoTotalBovinoculturaCorte"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Mão de obra</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Salários + encargos</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoSalarioEncargosTotal"
                  v-model="formulario.ServicoSalarioEncargosTotal"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoSalarioEncargosPorcentagem"
                  v-model="formulario.ServicoSalarioEncargosPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Gratificações</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoGratificacoesTotal"
                  v-model="formulario.ServicoGratificacoesTotal"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoGratificacoesPorcentagem"
                  v-model="formulario.ServicoGratificacoesPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Mão de obra temporária (Diaristas)</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoMaoDeObraTemporariaTotal"
                  v-model="formulario.ServicoMaoDeObraTemporariaTotal"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoMaoDeObraTemporariaPorcentagem"
                  v-model="formulario.ServicoMaoDeObraTemporariaPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Serviços técnicos (Profissinais das ciências agrárias)</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoServicosTecnicos"
                  v-model="formulario.ServicoServicosTecnicos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Impostos e aaxas</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Taxas e impostos incidentes sobre a bovinocultura de corte</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoTaxaImpostos"
                  v-model="formulario.ServicoTaxaImpostos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>ITR pago</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoItrPago"
                  v-model="formulario.ServicoItrPago"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Proporção da área da fazenda dedicada á bovinocultura de corte</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoProporcaoAreaFazenda"
                  v-model="formulario.ServicoProporcaoAreaFazenda"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Despesas administrativas</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Anuidades de sindicatos e associações</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoAnuidadesSindicatos"
                  v-model="formulario.ServicoAnuidadesSindicatos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoAnuidadesSindicatosPorcentagem"
                  v-model="formulario.ServicoAnuidadesSindicatosPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Comissões de compras e vendas</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoComissoesComprasVendas"
                  v-model="formulario.ServicoComissoesComprasVendas"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Escritório de contabilidade</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoEscritorioContabilidade"
                  v-model="formulario.ServicoEscritorioContabilidade"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoEscritorioContabilidadePorcentagem"
                  v-model="formulario.ServicoEscritorioContabilidadePorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Material para identificação do gado</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoMaterialIdentificacaoGado"
                  v-model="formulario.ServicoMaterialIdentificacaoGado"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Fretes para a bovinocultura de corte</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoFretesBovinocultura"
                  v-model="formulario.ServicoFretesBovinocultura"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Energia elétrica</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoEnergiaEletrica"
                  v-model="formulario.ServicoEnergiaEletrica"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoEnergiaEletricaPorcentagem"
                  v-model="formulario.ServicoEnergiaEletricaPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Telefone</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoTelefone"
                  v-model="formulario.ServicoTelefone"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoTelefonePorcentagem"
                  v-model="formulario.ServicoTelefonePorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm5 md5>
            <div class="divider2 text-xs-center">
              <span>
                <b>Seguros</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoSeguros"
                  v-model="formulario.ServicoSeguros"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoSegurosPorcentagem"
                  v-model="formulario.ServicoSegurosPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Outras despesas</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Despesas diversas</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoDespesasDiversas"
                  v-model="formulario.ServicoDespesasDiversas"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="ServicoDespesasDiversasPorcentagem"
                  v-model="formulario.ServicoDespesasDiversasPorcentagem"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
                {{form}}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosDespesasServicos from "../../class/DadosDespesasServicos";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosDespesasServicos(),
    panel: [],
    select: null,
    items: ["Sim", "Não"],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosDespesasServicos(dado.dadosDespesasServicos);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>